import { render, staticRenderFns } from "./ReferralArticle.vue?vue&type=template&id=37529a83&scoped=true&"
import script from "./ReferralArticle.vue?vue&type=script&lang=js&"
export * from "./ReferralArticle.vue?vue&type=script&lang=js&"
import style0 from "./ReferralArticle.vue?vue&type=style&index=0&id=37529a83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37529a83",
  null
  
)

export default component.exports